import { Box, Stack, Typography } from '@mui/material';
import FileButton from '../ui/FileButton';
import { useAppNavigate } from '../../../../Hooks/back/useAppNavigate';
import PinchZoom from '../../../../Components/Ui/PinchZoom';

export default function M_FILE_BASIC_03(props) {
  const { navigate } = useAppNavigate();

  return (
    <>
      <Stack sx={{ display: 'flex', alignItems: 'start', mb: 2, mt: 0 }}>
        <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
          작업허가서
        </Typography>
        <Typography sx={{ color: '#828282' }}>
          PDF 자료를 통해 작업허가서를 확인해주세요.
        </Typography>
      </Stack>

      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        sx={{
          width: '100%',
          overflow: 'hidden', // 스크롤 방지
        }}
      >
        {props.loading ? (
          <Typography
            sx={{
              minHeight: '200px',
              textAlign: 'center',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#4b4949ff',
              mt: 2,
            }}
          >
            작업허가서를 불러오는 중...
          </Typography>
        ) : props.pdfImages.length > 0 ? (
          <PinchZoom
            contents={props.pdfImages.map((src, idx) => (
              <img
                key={idx}
                src={src}
                alt={`PDF page ${idx + 1}`}
                style={{ width: '100%', marginBottom: '10px' }}
              />
            ))}
          />
        ) : (
          <Typography
            sx={{
              minHeight: '200px',
              textAlign: 'center',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#4b4949ff',
              mt: 2,
            }}
          >
            작업허가서가 없습니다.
          </Typography>
        )}

        <FileButton
          saveText={'완료'}
          onCancel={props.goToPrevPage}
          onClick={() => {
            navigate('/Home');
          }}
        />
      </Box>
    </>
  );
}
